module.exports = __webpack_public_path__ + "media/logos/bloomberg-law-logo-black-f731ac6a.png";